import React from "react";
import TabHeader from "../TabHeader";
import MatchingForm from "./MatchingForm/MatchingForm";
import "./MatchingContent.css";

class MatchingContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <section className="account-tab">
        <TabHeader
          tabHeaderTitle="Matching criteria"
          tabHeaderText="Improve the spend that you'll match with founders, or match with a different group of people."
          tabHeaderText2="Adjust your matching criteria here."
        />
        <MatchingForm
          showSuccessBox={this.props.showSuccessBox}
          showErrorBox={this.props.showErrorBox}
        />
      </section>
    );
  }
}

export default MatchingContent;
